import React, { useState } from 'react';
import { Box, IconButton, useBreakpointValue, Image, Card, Link } from '@chakra-ui/react';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import Slider from 'react-slick';

export default function Carousel({cards}) {
  const settings = {
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const [slider, setSlider] = useState(null);
  const top = useBreakpointValue({ base: '90%', md: '30%' });
  const side = useBreakpointValue({ base: '30%', md: '20px' });

  return (
    <Box
      position="relative"
      width="full"
      className='basic-carousel'
      >
      {/* CSS files for react-slick */}
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      {/* Left Icon */}
      <IconButton
        color={'black'}
        aria-label="left-arrow"
        position="absolute"
        height={16}
        backgroundColor={'white'}
        borderRadius={1}
        opacity={.9}
        left={side}
        top={top}
        transform={'translate(0%, -50%)'}
        zIndex={2}
        ml={-6}
        _hover={{
          opacity: "1"
        }}
        onClick={() => slider?.slickPrev()}>
        <ChevronLeft />
      </IconButton>
      {/* Right Icon */}
      <IconButton
        color={'black'}
        aria-label="right-arrow"
        position="absolute"
        height={16}
        backgroundColor={'white'}
        borderRadius={1}
        opacity={.9}
        right={side}
        top={top}
        transform={'translate(0%, -50%)'}
        zIndex={2}
        mr={-6}
        _hover={{
          opacity: "1"
        }}
        onClick={() => slider?.slickNext()}>
        <ChevronRight />
      </IconButton>
      <Slider {...settings} ref={(slider) => setSlider(slider)}>
        {cards && cards.map((card, index) => (
         <Box
            key={index}
            position="relative">
            <Card.Root variant="subtle"
                key={index}
                height={'100%'}
                ml={2}
                mr={2}
                position="relative"
              >
              <Image src={card.image} />
              <Card.Body>
                <Card.Title
                  fontSize={'var(--step-1)'}>
                  {card.heading}
                </Card.Title>
                <Card.Description>
                  {card.text}
                </Card.Description>
                  <Link href={card.link}>{card.linktext}</Link>
              </Card.Body>
            </Card.Root>
            </Box>
        ))}
      </Slider>
    </Box>
  );
}
